import { useState, useEffect, useRef  } from 'react'
import {AccreditationEventIssuanceCriteria } from "./components/accreditation/AccreditationEventIssuanceCriteria";
import { AccreditationInfo } from "./components/accreditation/AccreditationInfo";
import AccreditationAgencySelector from './components/accreditation/AccreditationAgencySelector'

const AccreditationUI = props => {

  //console.log('props: ',props)
  const {
    agencies,
  } = props
  const scheduledTypesArgs = window.tgblCredScheduledTypesArgs;
  const contentChoices = JSON.parse(props.contentChoices);
  const value = JSON.parse(props.value);

  const tangibleFields = <window className="tangibleFields"></window>
  const [ agencyId, setAgencyId] = useState( value.agency_id ?? 0 )

  return (
    <div className="tgbl-accreditation-ui">

      <div className="tgbl-accreditation-info-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Accreditation Info</h2></div>

        <AccreditationAgencySelector
          agencyId={agencyId}
          setAgencyId={setAgencyId}
          agencies={agencies}
        />

        <AccreditationInfo
          value={value}
          scheduledTypesArgs={scheduledTypesArgs}
          agencyId={agencyId}
        />
      </div>

      {/*
      <div className="tgbl-points-settings-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Points Settings</h2></div>
        <div className="tgbl-group" style={{border: '1px dashed', padding: '5px'}}>
          <h3>Points Settings Fields: data from the Accrediting Agency selected on the top - TODO </h3>
        </div>
      </div>
      */}

      <div className="tgbl-event-issuance-criteria-block tgbl-field-block">
        <div className="tgbl-block-title"><h2>Event Issuance Criteria</h2></div>
        <AccreditationEventIssuanceCriteria
          value={value}
          contentChoices={contentChoices}
          scheduledTypesArgs={scheduledTypesArgs}
          agencyId={agencyId}
          />
      </div>
    </div>
  )
}

export { AccreditationUI }
